import { Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import moment from 'moment';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { PersonSearchListing, PersonSearchService } from 'src/app/_services/person-search.service';
declare const clevertap;

@Component({
    selector: 'app-quick-search',
    templateUrl: './quick-search.component.html',
    styleUrls: ['./quick-search.component.scss'],
    standalone: false
})
export class QuickSearchComponent implements OnInit {

  isBooleanString = false;
  personSearchListing: PersonSearchListing[] = [];
  showViewAll: any;
  showHistoryViewAll: any;
  showSavedHistoryViewAll: any;

  private typeAheadSubject = new Subject<{ event: Event }>();
  historySubject : Subject<any> = new Subject<any>();
  savedHistorySubject : Subject<any> = new Subject<any>();

  searchFromDropdown: Boolean = false;
  showQuickSearchLoader: boolean = false

  searchedData: any;
  keywordsearch_form: UntypedFormGroup;

  quicksearcherror = "";

  searchChips = ['jobtitle', 'company', 'skill', 'Person'];

  constructor(
    private router: Router, private personSearchService: PersonSearchService,
    private localStorageService: LocalStorageService
  ) { }

  ngOnInit() {
    this.typeAheadSubject.pipe(debounceTime(500)).subscribe(({ event }) => this.typeaheadsearch(event));
    this.keywordsearch_form = new UntypedFormGroup({
      keyword: new UntypedFormControl('', [Validators.required,ValidateHTMLTAGS ])
    });

    function ValidateHTMLTAGS(control: AbstractControl){
      if(typeof control.value === 'string'){
        const res = control.value.replace(/ /g, '')
        let scriptRegex = /<(.*)>/g;
        if(res && (scriptRegex.test(res.trim()) == true)){
          return { 'pattern': true }
        }else{
          return null
        }
      } else {
               const res = control.value.value.replace(/ /g, '')
        let scriptRegex = /<(.*)>/g;
        if(res && (scriptRegex.test(res.trim()) == true)){
          return { 'pattern': true }
        }else{
          return null
        }
    }
  }
}

  // Call the function whenever user type something
  getPersonSearchListing(event: Event) {
    this.isBooleanString = false;

    // Emit the type and event as object through typeAheadSubject to apply debouce
    const searchValue = (event.target as HTMLInputElement).value;
    this.setIsBooleanSearch(searchValue);
    this.typeAheadSubject.next({ event });
  }

  selectSearch(value) {
    this.searchFromDropdown = false;
    this.searchedData = value;
    if (typeof this.searchedData === 'string') {
      this.keywordsearch_form.patchValue({
        keyword: this.searchedData
      })
    } else {
      this.keywordsearch_form.patchValue({
        keyword: this.searchedData.value
      })
    }
    this.search();
  }

  search() {
    if (this.keywordsearch_form.valid && this.quicksearcherror === "") {
      const searchParams = {
        "User ID": this.localStorageService.getItem('userdata').userid,
        "Search Type": "Boolean",
        "Time": moment().format()
      }
      clevertap.event.push('Search Initiated', searchParams);
      console.log("Search Boolean Initiated CT Event");
      this.router.navigate(
        ['/person/search/listing'],
        { queryParams: this.queryParamsForSearch }
      );
    }
  }

  private get queryParamsForSearch() {
    const searchType = this.searchedData && this.searchedData.type ? this.searchedData.type : 'searchKeyword';

    // const keywordSearch = this.hashService.encryptString(this.keywordsearch_form.controls['keyword'].value.trim())

    return {
      keyword: searchType == 'searchKeyword' ? this.keywordsearch_form.controls['keyword'].value.trim() : '',
      type: 'quick-search',
      filtertype: searchType == 'Person' ? 'fullname' : searchType,
      filtervalue: this.keywordsearch_form.controls['keyword'].value.trim(),
      title: searchType == 'fullname' ? this.searchedData.job_title : null,
      company: searchType == 'fullname' ? this.searchedData.job_company_name : null,
      searchedFrom: this.searchFromDropdown ? 'SearchChips' : null
    };
  }

  typeaheadsearch(event: Event) {
    this.isBooleanString = false;
    const searchValue = (event.target as HTMLInputElement).value.trim();

    if (searchValue == '*') {
      this.quicksearcherror = 'It looks like there aren’t many great matches for your search. Try searching for a skill, job title, industry or company.';
      return;
    }

    if (searchValue.length >= 3) {
      this.quicksearcherror = '';
      this.showQuickSearchLoader = true;

      this.personSearchService.getPersonSearchListing(
        searchValue, null
      ).subscribe((response: any) => {
        if (response?.status == 'success') {
          this.personSearchListing = response?.data?.slice(0, 10);
          this.showQuickSearchLoader = false;
        }
      });
    } else if (searchValue?.length < 3 && searchValue != '') {
      this.quicksearcherror = 'It looks like there aren’t many great matches for your search. Try searching for a skill, job title, industry or company.';
    } else {
      this.personSearchListing = [];
    }

    this.setIsBooleanSearch(searchValue);
  }

  searchFromListing(type) {
    this.searchedData = {
      type: type,
      value: this.keywordsearch_form.getRawValue().keyword
    };
    this.searchFromDropdown = true;
    this.search();
  }

  checkTalentpool(event){
    this.showViewAll =  event;
  }

  checkHistory(event, saveMode: boolean = false){
    if(event === 'REFRESH') {
      this.savedHistorySubject.next(event);
    } else {
      this[saveMode ? 'showSavedHistoryViewAll' : 'showHistoryViewAll'] = event;
    }
  }

  private setIsBooleanSearch(searchValue: string) {
    const booleanRegex = /AND|and|OR|or|NOT|not|\(|"/;
    this.isBooleanString = booleanRegex.test(searchValue);
  }

  viewAllHistory(saveMode: boolean = false){
    this[saveMode ? 'savedHistorySubject' : 'historySubject'].next(undefined as any);
  }

  redirectToTalentpool(){
    this.router.navigateByUrl("/talent/talentpool")
  }


}


